module.exports = __webpack_public_path__ + "static/media/12.61087436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/12.jpg
// module id = 205
// module chunks = 0